<template>
  <div class="content">
    <!-- 头部部分 -->
    <div class="head">
      <!-- 展示的搜索条件 -->
      <div class="searchOne">
        <el-input v-model="queryParams.productName" placeholder="套餐名"  @keyup.enter.native="search" clearable></el-input>
        <el-select v-model="queryParams.status" filterable placeholder="状态" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <!-- 搜索的按钮 -->
      <span class="span-but">
        <!-- <button type="button" class="el-button icon-button-auto el-button--default el-button--small" @click="hidden">
          <i class="el-icon-d-arrow-right" :class="{rotating:an}"></i>
        </button> -->
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
      </span>
      <!-- 隐藏的搜索条件 -->
      <div v-show="an" class="array-class">

      </div>
    </div>
    <!-- 内容部分 -->
    <div class="content-class">
      <div style="margin-top: 10px">
        <el-table :data="tableData" border>
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
          <el-table-column prop="flowCount" label="流量(M)" align="center"></el-table-column>
          <el-table-column prop="validityTime" label="有效期(天)" align="center"></el-table-column>
          <el-table-column prop="integral" label="积分" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag v-if="row.status == 1">启用中</el-tag>
              <el-tag v-else type="danger">未启用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="editRow(scope.row)" style="background:#B6A2DE;border: 1px solid #B6A2DE;">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <!-- 弹窗部分 -->
      <commonDialog 
        :visible.sync="dialogVisible"
        :dialogTitle="dialogTitle"
        :popupWidth="popupWidth"
        @dialogClose="dialogClose"
        @cancel="cancel"
        @save="save"
        @updateVisible="updateVisible"
      >
        <template>
          <el-form :model="propsParams" :rules="ruleValidate" ref="propsParams">
            <el-form-item label="资费套餐:" prop="productId" label-width="100px">
              <el-select
                v-model="propsParams.productId"
                default-first-option
                filterable
                placeholder="请选择资费套餐"
                style="width:95%"
                :disabled = selectDisabled
              >
                <el-option
                  v-for="item in optPackage"
                  :key="item.id"
                  :label="item.productName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所需积分:" prop="integral" label-width="100px">
              <el-input v-model="propsParams.integral" autocomplete="off" style="width:95%" placeholder="请输入所需积分"></el-input>
            </el-form-item>
            <el-form-item label="是否启用:" prop="status" label-width="100px">
              <el-switch v-model="propsParams.status" active-color="#13ce66"></el-switch>
            </el-form-item>
          </el-form>
        </template>
      </commonDialog>
    </div>
  </div>
</template>
<script>
import { productList } from "@/api/api.js"; //不分页套餐列表
import { integralExchangeList } from "@/api/api.js";
import { saveIntegralExchangeProduct } from "@/api/api.js";
import commonDialog from "@/components/dialogComponent/commonDialog.vue"; //弹窗
export default {
  name:'ruleList',
  data() {
    var validateNumber = (rule, value, callback) => {
    let numberReg = /^\d+$|^\d+[.]?\d+$/
    if (value !== '') {
      if (!numberReg.test(value)) {
        callback(new Error('请输入数字'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入所需积分'))
      }
    }
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      operator:[
        { value: 0, label: "未启用" },
        { value: 1, label: "启用中" },
      ],

      selectDisabled:false,
      dialogVisible:false,
      dialogTitle:"",
      popupWidth:"500px",
      propsParams:{
        status:true
      },
      optPackage: [],
      ruleValidate:{
        productId:[
          { required: true, message: "请选择资费套餐", trigger: "blur" }
        ],
        integral: [
          { required: true,validator: validateNumber, trigger: 'blur' }
        ],
      }
    }
  },
  components:{
    commonDialog,
  },
  methods: {
    hidden(){
      this.an = this.an == false ? true : false
    },
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      integralExchangeList(params).then(res =>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) =>{
            item.ids = index + 1;
            item.productName = item.productId + "-" + item.productName
          })
        }
      })
    },
    // 资费套餐下拉
    queryServerList() {
      productList().then(res => {
        if (res.data.code == 200) {
          this.optPackage = res.data.data;
          this.optPackage.map((item) => {
            item.productName = `${item.id}-${item.productName}`
          })
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      }
      this.initData();
    },
    // 添加数据
    addItem(){
      this.selectDisabled = false;
      this.dialogVisible = true;
      this.dialogTitle = "新增规则";
      for(let i in this.propsParams){
        this.propsParams[i] = "";
        this.propsParams["status"] = true
      }
    },
    // 编辑数据
    editRow(val){
      this.selectDisabled = true;
      this.dialogVisible = true;
      this.dialogTitle = "编辑规则";
      this.$set(this.propsParams,'productId',val.productId);
      this.$set(this.propsParams,'integral',val.integral);
      if(val.status == 1 ){
        this.$set(this.propsParams,'status',true);
      }else{
        this.$set(this.propsParams,'status',false);
      }
    },
    // 弹窗右上角关闭按钮
    dialogClose(){
      this.$refs.propsParams.clearValidate();
      this.dialogVisible = false
    },
    // 弹窗取消按钮
    cancel(){
      this.$refs.propsParams.clearValidate();
      this.dialogVisible = false;
    },
    // 弹窗确定按钮
    save(){
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          let params ={
            ...this.propsParams,
          }
          params.status =  params.status == true ? 1:0;
          saveIntegralExchangeProduct(params).then(res => {
            if (res.data.code == 200) {
              this.$notify({
                title: '成功',
                message: '兑换规则创建成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.initData();
            }else{
              this.$message.error(res.data.message);
            }
          })
        }
      })
    },
    updateVisible(val){
      this.dialogVisible = val;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  created() {
    this.initData();
    this.queryServerList();
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
</style>


